/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {StatefulComponent} from '../../../../shared/stateful/stateful.component';
import {
    BundlingSettingsTabModel
} from '../../../bundles-main-page/models/bundling-settings-tabs/bundling-settings-tab.model';
import {BundlingSettingsTabsModel} from './models/bundling-settings-tabs.model';

@Component({
    selector: 'app-bundling-settings-tabs',
    templateUrl: './bundling-settings-tabs.component.html',
    styleUrls: ['./bundling-settings-tabs.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class BundlingSettingsTabsComponent extends StatefulComponent<BundlingSettingsTabsModel> implements OnInit{
    @Input() tabs: BundlingSettingsTabModel[];
    @Input() activeTab: string;
    @Input() changeActiveTab: EventEmitter<string>;
    @Output() emitTab = new EventEmitter<string>();

    ngOnInit(): void  {
        this.storeState({
            columnGrid: this.getGridTemplateColumnsTabs(),
            activeTab: this.activeTab
        });
        this.changeActiveTab?.subscribe((tab: string) => {
            this.storeState({activeTab: tab});
        });
    }

    isTabActive(tab: string): boolean {
        return tab === this.state.activeTab;
    }

    clickTab(tab: string): void {
        this.emitTab.emit(tab);
    }

    getTabDynamicDataCy(tabCode: string): string {
        return `bundling-settings-tabs-button-${tabCode}`;
    }

    private getGridTemplateColumnsTabs(): Record<string, string> {
        if (this.tabs?.length > 0) {
            const gridTemplate = this.tabs?.map(() => '1fr')
                    .join(' ');
            return {'grid-template-columns': gridTemplate};
        }
    }
}
